import { Link, router } from '@inertiajs/react';
import { Button } from 'antd';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'iconsax-react';
import child from '@/../../public/child.jpg';

interface Blog {
    id: number;
    title: string;

    name_one: string;
    name_two: string;
    image: string;
    slug: string;
}

interface BlogsProps {
    blogs: Blog[];
}

const Blogs: React.FC<BlogsProps> = ({ blogs }) => {
    const { t, i18n } = useTranslation();
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
    const [bgPosition, setBgPosition] = useState(0);

    const BlogsIndex = () => {
        router.get(route('client.blogs.index', { locale: i18n.language }));
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setBgPosition((prevPosition) => (prevPosition + 0.1) % 100); // Increment by 0.1 for smoother movement
        }, 50); // Adjust the interval time to slow down the animation

        return () => clearInterval(interval);
    }, []);

    const list = [
        {
            title: "صحة ",
            title2: "الأطفال",
            childtitle: "للعناية بصحة اطفالك يرجى اتباع التعليمات الأتية"
        },
        {
            title: "صحة ",
            title2: "الأطفال",
            childtitle: "للعناية بصحة اطفالك يرجى اتباع التعليمات الأتية"
        },
        {
            title: "صحة ",
            title2: "الأطفال",
            childtitle: "للعناية بصحة اطفالك يرجى اتباع التعليمات الأتية"
        },
        {
            title: "صحة ",
            title2: "الأطفال",
            childtitle: "للعناية بصحة اطفالك يرجى اتباع التعليمات الأتية"
        },
        {
            title: "صحة ",
            title2: "الأطفال",
            childtitle: "للعناية بصحة اطفالك يرجى اتباع التعليمات الأتية"
        },
    ];

    return (
        <div className="m-5 py-5 px-8">
            <div className="my-5 p-5 flex justify-between items-center">
                <p className='text-custom-dark-blue font-bold text-sm lg:text-base px-4 py-4  dark:!text-white '>{t('ourblog.blogs')}</p>

            </div>

            <div className='flex justify-evenly items-center gap-4 xs:flex-wrap'>
                {blogs.map((item, index) => (
                    <div
                        key={index}
                        className='relative border rounded-xl w-1/2 xs:w-full h-[380px] flex justify-between overflow-hidden items-center flex-col cursor-pointer group hover:w-full duration-300 hover:h-[420px] bg-white bg-center bg-cover dark:bg-black group'
                        style={{
                            backgroundImage: hoveredIndex === index ? `url('${item.image}')` : 'none',
                            backgroundPosition: `${bgPosition}% 0%`,
                        }}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <div className=' w-full h-full bg-black top-0 right-0 opacity-50 absolute hidden group-hover:block'></div>
                        <div className='relative z-50'>
                            <p className="text-custom-dark-blue text-sm lg:text-base px-4 text-right font-bold dark:text-white duration-300 ">
                                {item.name_one}
                                {/* {item.title.length > 20 ? `${item.title.slice(0, 20)}...` : item.title} */}
                            </p>
                            <p className="text-custom-dark-blue text-sm lg:text-base font-bold px-4 text-center dark:text-white duration-300">
                                {item.name_two}
                            </p>
                        </div>
                        <p className="text-black text-sm lg:text-base font-medium px-4 text-center dark:text-white duration-300 group-hover:text-white  z-50 relative group-hover:w-1/2 xs:group-hover:w-full">
                            {item.title}
                        </p>

                        <Link
                            href={route('client.blogs.show', { locale: i18n.language, slug: item.slug })}
                            className='font-sans text-xl bg-white border text-custom-dark-blue rounded-xl group-hover:mb-32 w-[200px]  p-2 group-hover:block hidden hover:bg-custom-dark-blue hover:text-white  z-50 relative'
                        >
                            <div className='flex justify-between items-center'>
                                <p>{t('form.blogs.read_more')}</p>
                                <ArrowLeft />
                            </div>
                        </Link>

                        <Link
                            href={route('client.blogs.show', { locale: i18n.language, slug: item.slug })}
                            className='font-sans text-sm lg:text-base bg-custom-dark-blue text-white w-full p-2 flex justify-between items-center group-hover:hidden'
                        >
                            {t('form.blogs.read_more')}
                            <ArrowLeft />
                        </Link>
                    </div>
                ))}
            </div>
            <div className='items-center justify-end flex'>
            <Button className="rounded-full p-4 text-sm lg:text-base font-normal hover:!bg-custom-dark-blue hover:!text-white font-sans hover:!border-white dark:!text-white mt-4 " onClick={BlogsIndex}>
                {t('btn.showmore')}
            </Button>
            </div>
        </div>
    );
};

export default Blogs;